(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  class RecipeFilters extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-recipe-filter]');
      this.cards = this.querySelectorAll('[data-recipe-card]');
      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.setFilter(button));
      });
    }

    setFilter(button) {
      this.buttons.forEach((b) => b.classList.toggle('is-active', b === button));
      const filter = button.dataset.recipeFilter;
      this.cards.forEach((card) => {
        const tags = card.dataset.recipeTags || '';
        card.hidden = filter !== 'all' && !tags.includes(filter);
      });
    }
  }

  customElements.define('recipe-filters', RecipeFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cart-dialog]');
      this.closeButton = this.querySelector('[data-cart-close]');
      this.body = this.querySelector('[data-cart-body]');
      this.errorEl = this.querySelector('[data-cart-error]');
      this.cartUrl = this.dataset.cartUrl;
      this.productsUrl = this.dataset.productsUrl;

      this.closeButton.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('close', () => {
        this.dialog.classList.remove('is-open');
      });

      document.addEventListener('cart:open', () => this.open());
      document.addEventListener('cart:refresh', async () => {
        await this.refreshCart();
        await this.refreshRecommendations();
        this.open();
      });

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (!form.action.includes('/cart/add')) return;
        event.preventDefault();
        this.addToCart(new FormData(form));
      });

      this.body.addEventListener('click', (event) => {
        const decrease = event.target.closest('[data-cart-decrease]');
        const increase = event.target.closest('[data-cart-increase]');
        const remove = event.target.closest('[data-cart-remove]');
        const quickAdd = event.target.closest('[data-cart-quick-add]');

        if (decrease) this.changeLine(decrease, -1);
        else if (increase) this.changeLine(increase, 1);
        else if (remove) this.removeLine(remove.dataset.line);
        else if (quickAdd) this.addVariant(quickAdd.dataset.variantId);
      });

      this.refreshRecommendations();
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close() {
      this.dialog.classList.remove('is-open');
      setTimeout(() => {
        if (this.dialog.open) this.dialog.close();
      }, 300);
    }

    async addToCart(formData) {
      this.body.classList.add('is-loading');
      this.showError('');
      const response = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
      if (!response.ok) {
        const data = await response.json().catch(() => null);
        this.showError((data && (data.description || data.message)) || this.dataset.errorGeneric);
        this.body.classList.remove('is-loading');
        this.open();
        return;
      }
      await this.refreshCart();
      await this.refreshRecommendations();
      this.body.classList.remove('is-loading');
      this.open();
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    addVariant(variantId) {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      this.addToCart(formData);
    }

    async changeLine(button, delta) {
      const line = button.dataset.line;
      const qtyEl = button.closest('.cart-drawer__item-quantity').querySelector('[data-cart-qty]');
      const nextQty = Math.max(0, parseInt(qtyEl.textContent, 10) + delta);
      this.body.classList.add('is-loading');
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: nextQty }),
      });
      await this.refreshCart();
      await this.refreshRecommendations();
      this.body.classList.remove('is-loading');
    }

    async removeLine(line) {
      this.body.classList.add('is-loading');
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: 0 }),
      });
      await this.refreshCart();
      this.body.classList.remove('is-loading');
    }

    async refreshCart() {
      const response = await fetch(`${this.cartUrl}?section_id=cart-drawer`);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const freshBody = doc.querySelector('[data-cart-body]');
      if (!freshBody) return;
      this.body.innerHTML = freshBody.innerHTML;
      this.body.dataset.primaryProductHandle = freshBody.dataset.primaryProductHandle || '';
      const countEl = this.body.querySelector('[data-cart-count-value]');
      const count = countEl ? parseInt(countEl.textContent, 10) : 0;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count } }));
    }

    async refreshRecommendations() {
      const container = this.body.querySelector('[data-cart-recommendations]');
      const handle = this.body.dataset.primaryProductHandle;
      if (!container) return;
      if (!handle) {
        container.innerHTML = '';
        return;
      }
      const url = `${this.productsUrl}/${handle}?section_id=cart-drawer`;
      const response = await fetch(url);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-recommendations-response]');
      container.innerHTML = fresh ? fresh.innerHTML : '';
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-distribution-note]').forEach((noteInput) => {
    const form = noteInput.closest('form');
    if (!form) return;
    form.addEventListener('submit', () => {
      const company = form.querySelector('[data-distribution-company]');
      const state = form.querySelector('[data-distribution-state]');
      const parts = [];
      if (company && company.value) parts.push(`Empresa: ${company.value}`);
      if (state && state.value) parts.push(`Estado a distribuir: ${state.value}`);
      noteInput.value = parts.join(' | ');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-menu-toggle]');
      this.dialog = this.querySelector('[data-menu-dialog]');
      this.closeButton = this.querySelector('[data-menu-close]');
      this.header = this.querySelector('.header');

      this.toggle.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('close', () => {
        this.toggle.setAttribute('aria-expanded', 'false');
      });

      this.querySelectorAll('.header__panel-summary').forEach((summary) => {
        const details = summary.closest('details');
        const link = summary.querySelector('.header__panel-summary-link');
        // Summary's native click-to-toggle would otherwise fire for any
        // click landing in its box — only suppress it when the tap isn't
        // on the real "Comprar" link, so the link keeps navigating
        // normally and the toggle button drives open/close explicitly.
        summary.addEventListener('click', (event) => {
          if (!link.contains(event.target)) event.preventDefault();
        });
        summary.querySelector('.header__panel-summary-toggle').addEventListener('click', () => {
          details.open = !details.open;
        });
      });

      this.headerOffset = null;
      this.updatePinned = this.updatePinned.bind(this);
      this.updatePinned();
      window.addEventListener('scroll', this.updatePinned, { passive: true });
      window.addEventListener('resize', () => {
        this.headerOffset = null;
        this.updatePinned();
      });

      this.cartIcon = this.querySelector('[data-cart-icon]');
      this.cartCount = this.querySelector('[data-cart-icon-count]');
      if (this.cartIcon) {
        this.cartIcon.addEventListener('click', (event) => {
          event.preventDefault();
          document.dispatchEvent(new CustomEvent('cart:open'));
        });
      }
      document.addEventListener('cart:updated', (event) => {
        if (!this.cartCount) return;
        const count = event.detail.count;
        this.cartCount.textContent = count;
        this.cartCount.hidden = count === 0;
      });
    }

    updatePinned() {
      if (this.headerOffset === null) {
        const wasPinned = this.header.classList.contains('header--pinned');
        if (wasPinned) this.header.classList.remove('header--pinned');
        this.headerOffset = this.header.getBoundingClientRect().top + window.scrollY;
        if (wasPinned) this.header.classList.add('header--pinned');
      }
      this.header.classList.toggle('header--pinned', window.scrollY > this.headerOffset);
    }

    open() {
      this.dialog.showModal();
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.dialog.close();
    }
  }

  customElements.define('header-menu', HeaderMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presale-launch"] && !Shopify.designMode) return;
  try {
    
  class PresaleLaunch extends HTMLElement {
    connectedCallback() {
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.finePointer = window.matchMedia('(pointer: fine)').matches;
      this.hero = this.querySelector('[data-hero]');
      this.intro = this.querySelector('[data-intro]');
      this.marquee = this.querySelector('[data-marquee]');
      this.lineup = this.querySelector('[data-lineup]');
      this.traveler = this.querySelector('[data-traveler]');
      this.sticky = this.querySelector('[data-presale-sticky]');
      this.observers = [];

      this.classList.add('is-enhanced');
      this.initReveal();
      this.initSticky();
      this.initLineup();
      this.initDragScroll();

      if (this.reducedMotion) return;
      this.classList.add('is-animated');
      this.initScroll();
      if (this.finePointer) {
        this.initMagnetic();
        this.initTilt();
      }
    }

    disconnectedCallback() {
      this.observers.forEach((observer) => observer.disconnect());
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }
    }

    /* Mouse drag for the gallery strip; touch and keyboard use native scrolling. */
    initDragScroll() {
      this.querySelectorAll('[data-drag-scroll]').forEach((track) => {
        let startX = 0;
        let startScroll = 0;
        let moved = false;
        track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') return;
          startX = event.clientX;
          startScroll = track.scrollLeft;
          moved = false;
          track.classList.add('is-dragging');
          track.setPointerCapture(event.pointerId);
        });
        track.addEventListener('pointermove', (event) => {
          if (!track.classList.contains('is-dragging')) return;
          const delta = event.clientX - startX;
          if (Math.abs(delta) > 4) moved = true;
          track.scrollLeft = startScroll - delta;
        });
        const end = () => track.classList.remove('is-dragging');
        track.addEventListener('pointerup', end);
        track.addEventListener('pointercancel', end);
        track.addEventListener('click', (event) => {
          if (moved) event.preventDefault();
        }, true);
      });
    }

    observe(targets, callback, options) {
      if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => callback(el));
        return;
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          callback(entry.target);
          observer.unobserve(entry.target);
        });
      }, options);
      targets.forEach((el) => observer.observe(el));
      this.observers.push(observer);
    }

    initReveal() {
      const targets = this.querySelectorAll('[data-reveal], [data-reveal-lines]');
      this.observe(
        targets,
        (el) => {
          el.classList.add('is-visible');
          el.querySelectorAll('[data-count-up]').forEach((stat) => this.countUp(stat));
        },
        { rootMargin: '0px 0px -12% 0px' }
      );
    }

    initLineup() {
      if (!this.lineup) return;
      this.observe([this.lineup], (el) => el.classList.add('is-landed'), { threshold: 0.35 });
    }

    /* Animates the leading number of a stat ("14 kcal por lata") from 0. */
    countUp(el) {
      if (this.reducedMotion) return;
      const match = el.textContent.match(/^(\s*)(\d+(?:[.,]\d+)?)([\s\S]*)$/);
      if (!match) return;
      const [, lead, numberText, rest] = match;
      const decimals = (numberText.split(/[.,]/)[1] || '').length;
      const target = parseFloat(numberText.replace(',', '.'));
      const start = performance.now();
      const step = (now) => {
        const t = Math.min((now - start) / 1400, 1);
        el.textContent = lead + (target * (1 - Math.pow(1 - t, 3))).toFixed(decimals) + rest;
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }

    /* Show the sticky bar once the intro has scrolled into view (the hero is pinned, so watch the intro). */
    initSticky() {
      if (!this.sticky || !this.intro || !('IntersectionObserver' in window)) return;
      const buttons = this.sticky.querySelectorAll('button');
      const observer = new IntersectionObserver(([entry]) => {
        const show = entry.isIntersecting || entry.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-visible', show);
        this.sticky.setAttribute('aria-hidden', String(!show));
        buttons.forEach((button) => (button.tabIndex = show ? 0 : -1));
      });
      observer.observe(this.intro);
      this.observers.push(observer);
    }

    /* Traveler keyframes: positions in viewport units, anchored to section scroll positions. */
    buildKeyframes() {
      const vh = window.innerHeight;
      const top = (el) => el.getBoundingClientRect().top + window.scrollY;
      const desktop = window.innerWidth >= 768;
      const heroTop = top(this.hero);
      // First screen: the hero fills whatever the announcement bar + header leave.
      this.style.setProperty('--pl-hero-h', `${Math.max(vh - heroTop, vh * 0.7)}px`);
      const introTop = top(this.intro);
      const marqueeTop = top(this.marquee);
      const marqueeEnd = marqueeTop + this.marquee.offsetHeight - vh;
      const lineupTop = top(this.lineup);

      this.frames = desktop
        ? [
            { at: heroTop, x: 43, y: 50, r: -16, s: 1, o: 1 },
            { at: introTop - vh * 0.1, x: 30, y: 58, r: -34, s: 0.9, o: 1 },
            { at: introTop + this.intro.offsetHeight * 0.45, x: 10, y: 54, r: -12, s: 0.72, o: 1 },
            { at: marqueeTop, x: 50, y: 52, r: 10, s: 1, o: 1 },
            { at: marqueeEnd, x: 54, y: 50, r: -8, s: 1.05, o: 1 },
            { at: lineupTop - vh * 0.35, x: 44, y: 82, r: 0, s: 0.75, o: 1 },
            { at: lineupTop - vh * 0.05, x: 44, y: 96, r: 0, s: 0.6, o: 0 },
          ]
        : [
            { at: heroTop, x: 40, y: 38, r: -16, s: 0.62, o: 1 },
            { at: introTop - vh * 0.1, x: 26, y: 56, r: -30, s: 0.55, o: 1 },
            { at: introTop + this.intro.offsetHeight * 0.5, x: 78, y: 40, r: 14, s: 0.55, o: 1 },
            { at: marqueeTop, x: 50, y: 52, r: 10, s: 0.8, o: 1 },
            { at: marqueeEnd, x: 50, y: 50, r: -8, s: 0.85, o: 1 },
            { at: lineupTop - vh * 0.35, x: 50, y: 82, r: 0, s: 0.6, o: 1 },
            { at: lineupTop - vh * 0.05, x: 50, y: 96, r: 0, s: 0.5, o: 0 },
          ];
      this.heroRange = [heroTop, introTop];
      this.marqueeRange = [marqueeTop, marqueeEnd];
    }

    applyTraveler(scrollY) {
      const frames = this.frames;
      let a = frames[0];
      let b = frames[frames.length - 1];
      if (scrollY <= a.at) b = a;
      else if (scrollY >= b.at) a = b;
      else {
        for (let i = 0; i < frames.length - 1; i++) {
          if (scrollY >= frames[i].at && scrollY <= frames[i + 1].at) {
            a = frames[i];
            b = frames[i + 1];
            break;
          }
        }
      }
      const span = b.at - a.at || 1;
      const raw = Math.min(Math.max((scrollY - a.at) / span, 0), 1);
      const t = raw < 0.5 ? 4 * raw * raw * raw : 1 - Math.pow(-2 * raw + 2, 3) / 2;
      const mix = (key) => a[key] + (b[key] - a[key]) * t;
      const style = this.traveler.style;
      style.setProperty('--tx', `${mix('x')}vw`);
      style.setProperty('--ty', `${mix('y')}vh`);
      style.setProperty('--tr', `${mix('r')}deg`);
      style.setProperty('--ts', mix('s').toFixed(3));
      style.setProperty('--to', mix('o').toFixed(3));
    }

    initScroll() {
      const packs = this.querySelectorAll('[data-parallax]');
      const blobs = this.querySelectorAll('[data-parallax-y]');
      let ticking = false;

      const update = () => {
        ticking = false;
        const y = window.scrollY;
        const vh = window.innerHeight;

        if (this.traveler && this.frames) this.applyTraveler(y);

        const [h0, h1] = this.heroRange;
        this.hero.style.setProperty('--hero-p', Math.min(Math.max((y - h0) / (h1 - h0 || 1), 0), 1).toFixed(3));

        const [m0, m1] = this.marqueeRange;
        this.marquee.style.setProperty('--mp', Math.min(Math.max((y - m0) / (m1 - m0 || 1), 0), 1).toFixed(4));

        blobs.forEach((blob) => {
          const rect = blob.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > vh) return;
          const offset = (rect.top + rect.height / 2 - vh / 2) * Number(blob.dataset.parallaxY);
          blob.style.setProperty('--py', offset.toFixed(1));
        });

        packs.forEach((pack) => {
          const rect = pack.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > vh) return;
          pack.style.setProperty('--parallax', ((vh - rect.top) / (vh + rect.height) - 0.5).toFixed(3));
        });
      };

      this.onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };
      this.onResize = () => {
        this.buildKeyframes();
        this.onScroll();
      };

      this.buildKeyframes();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      // Layout can shift once fonts/images load; rebuild anchors then.
      window.addEventListener('load', this.onResize, { once: true });
      update();
    }

    initMagnetic() {
      this.querySelectorAll('[data-magnetic]').forEach((button) => {
        button.addEventListener('pointermove', (event) => {
          const rect = button.getBoundingClientRect();
          button.style.setProperty('--mx', `${((event.clientX - rect.left - rect.width / 2) * 0.25).toFixed(1)}px`);
          button.style.setProperty('--my', `${((event.clientY - rect.top - rect.height / 2) * 0.35).toFixed(1)}px`);
        });
        button.addEventListener('pointerleave', () => {
          button.style.setProperty('--mx', '0px');
          button.style.setProperty('--my', '0px');
        });
      });
    }

    initTilt() {
      this.querySelectorAll('[data-tilt]').forEach((el) => {
        const media = el.parentElement;
        media.addEventListener('pointermove', (event) => {
          const rect = media.getBoundingClientRect();
          el.style.setProperty('--tx', ((event.clientX - rect.left) / rect.width - 0.5).toFixed(3));
          el.style.setProperty('--ty', ((event.clientY - rect.top) / rect.height - 0.5).toFixed(3));
        });
        media.addEventListener('pointerleave', () => {
          el.style.setProperty('--tx', '0');
          el.style.setProperty('--ty', '0');
        });
      });
    }
  }

  if (!customElements.get('presale-launch')) customElements.define('presale-launch', PresaleLaunch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presale-popup"]) return;
  try {
    
  class PresalePopup extends HTMLElement {
    static storageKey = 'ob-presale-popup-dismissed-at';

    connectedCallback() {
      this.dialog = this.querySelector('[data-popup-dialog]');
      if (!this.dialog) return;

      this.querySelectorAll('[data-popup-close]').forEach((button) =>
        button.addEventListener('click', () => this.close())
      );
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });

      if (this.hasAttribute('data-design-mode')) {
        document.addEventListener('shopify:section:select', (event) => {
          if (this.contains(event.target) || event.target.contains(this)) this.open();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (this.contains(event.target) || event.target.contains(this)) this.close(false);
        });
        return;
      }

      if (this.isSnoozed()) return;
      const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
      this.timer = setTimeout(() => this.open(), delay);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }

    isSnoozed() {
      try {
        const dismissedAt = Number(localStorage.getItem(PresalePopup.storageKey));
        const snooze = (Number(this.dataset.snoozeHours) || 24) * 3600000;
        return dismissedAt && Date.now() - dismissedAt < snooze;
      } catch (error) {
        return false;
      }
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close(remember = true) {
      if (remember) {
        try {
          localStorage.setItem(PresalePopup.storageKey, String(Date.now()));
        } catch (error) {
          /* storage unavailable: popup may show again next visit */
        }
      }
      this.dialog.classList.remove('is-open');
      setTimeout(() => {
        if (this.dialog.open) this.dialog.close();
      }, 300);
    }
  }

  if (!customElements.get('presale-popup')) customElements.define('presale-popup', PresalePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight"]) return;
  try {
    
  class ProductSpotlight extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-spotlight-tab]');
      this.panels = this.querySelectorAll('[data-spotlight-panel]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.show(tab.dataset.spotlightTab));
      });

      const initialPanel = this.querySelector('[data-spotlight-panel]:not([hidden])') || this.panels[0];
      if (initialPanel) {
        this.style.setProperty('--spotlight-accent', initialPanel.dataset.spotlightAccent);
      }
    }

    show(index) {
      this.tabs.forEach((tab) => {
        tab.classList.toggle('is-active', tab.dataset.spotlightTab === index);
        tab.setAttribute('aria-pressed', tab.dataset.spotlightTab === index);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.spotlightPanel !== index;
        if (panel.dataset.spotlightPanel === index) {
          this.style.setProperty('--spotlight-accent', panel.dataset.spotlightAccent);
        }
      });
    }
  }

  customElements.define('product-spotlight', ProductSpotlight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.images = this.querySelectorAll('[data-gallery-image]');
      this.thumbs = this.querySelectorAll('[data-gallery-thumb]');
      this.options = this.querySelectorAll('.product__option');
      this.ctaElement = this.querySelector('[data-cta]');
      this.variantInput = this.querySelector('[data-variant-input]');
      this.quantityInput = this.querySelector('[data-quantity-input]');

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.showImage(thumb.dataset.galleryThumb));
      });

      this.options.forEach((option) => {
        option.addEventListener('click', () => this.selectVariant(option));
      });

      const decrease = this.querySelector('[data-quantity-decrease]');
      const increase = this.querySelector('[data-quantity-increase]');
      if (decrease && increase && this.quantityInput) {
        decrease.addEventListener('click', () => this.stepQuantity(-1));
        increase.addEventListener('click', () => this.stepQuantity(1));
      }
    }

    stepQuantity(delta) {
      const next = Math.max(1, parseInt(this.quantityInput.value || '1', 10) + delta);
      this.quantityInput.value = next;
    }

    showImage(index) {
      this.images.forEach((image) => {
        image.hidden = image.dataset.galleryImage !== index;
      });
      this.thumbs.forEach((thumb) => {
        thumb.classList.toggle('is-active', thumb.dataset.galleryThumb === index);
      });
    }

    selectVariant(selectedOption) {
      this.options.forEach((option) => {
        const isSelected = option === selectedOption;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-pressed', isSelected);
      });

      this.variantInput.value = selectedOption.dataset.variantId;
      this.ctaElement.textContent = selectedOption.dataset.ctaLabel;

      const price = this.querySelector('[data-price]');
      const savings = this.querySelector('[data-savings]');
      if (price) price.textContent = selectedOption.dataset.price;
      if (savings) {
        savings.textContent = selectedOption.dataset.savings;
        savings.hidden = selectedOption.dataset.savings === '';
      }
    }
  }

  customElements.define('product-gallery', ProductGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-all"] && !Shopify.designMode) return;
  try {
    
  class ShopAllFilters extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-filter]');
      this.groups = this.querySelectorAll('[data-filter-group]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.filter(button.dataset.filter));
      });

      // Menu links like /pages/comprar#packs open the page pre-filtered.
      this.applyHash = () => {
        const value = window.location.hash.slice(1);
        if ([...this.buttons].some((button) => button.dataset.filter === value)) this.filter(value);
      };
      this.applyHash();
      window.addEventListener('hashchange', this.applyHash);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.applyHash);
    }

    filter(value) {
      this.buttons.forEach((button) => {
        const isActive = button.dataset.filter === value;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive);
      });

      this.groups.forEach((group) => {
        const matches = value === 'all' || group.dataset.filterGroup === value;
        group.hidden = !matches;
      });
    }
  }

  customElements.define('shop-all-filters', ShopAllFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-aperitivo"] && !Shopify.designMode) return;
  try {
    
  class ShopCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      const section = this.closest('.shop-the-aperitivo');

      section?.querySelectorAll('[data-carousel-prev]').forEach((button) => {
        button.addEventListener('click', () => this.scrollByCard(-1));
      });
      section?.querySelectorAll('[data-carousel-next]').forEach((button) => {
        button.addEventListener('click', () => this.scrollByCard(1));
      });
    }

    scrollByCard(direction) {
      const slide = this.track.querySelector('.shop-the-aperitivo__slide');
      if (!slide) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = (slide.getBoundingClientRect().width + gap) * direction;

      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }
  }

  customElements.define('shop-carousel', ShopCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe"]) return;
  try {
    
  class PlanSelector extends HTMLElement {
    connectedCallback() {
      this.buttons = this.querySelectorAll('[data-plan-option]');
      this.panels = document.querySelectorAll('[data-plan-panel]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.select(button.dataset.planOption));
      });
    }

    select(plan) {
      this.buttons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.planOption === plan);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.planPanel !== plan;
      });
    }
  }

  customElements.define('plan-selector', PlanSelector);

  class ProBuilder extends HTMLElement {
    connectedCallback() {
      this.boxSize = 2;
      this.items = [];

      this.sizeButtons = this.querySelectorAll('[data-pro-size-option]');
      this.bottles = this.querySelectorAll('[data-bottle]');
      this.slotsEl = this.querySelector('[data-pro-slots]');
      this.countEl = this.querySelector('[data-pro-count]');
      this.sizeLabelEl = this.querySelector('[data-pro-size-label]');
      this.savingsEl = this.querySelector('[data-pro-savings]');
      this.savingsAmountEl = this.querySelector('[data-pro-savings-amount]');
      this.savingsPercentEl = this.querySelector('[data-pro-savings-percent]');
      this.priceOnceEl = this.querySelector('[data-pro-price-once]');
      this.priceSubscribeEl = this.querySelector('[data-pro-price-subscribe]');
      this.purchaseTypeInputs = this.querySelectorAll('[data-pro-purchase-type]');
      this.frequencySelect = this.querySelector('[data-pro-frequency-select]');
      this.ctaButton = this.querySelector('[data-pro-add-to-cart]');

      this.sizeButtons.forEach((button) => {
        button.addEventListener('click', () => this.setBoxSize(button));
      });
      this.bottles.forEach((bottle) => {
        bottle.querySelector('[data-bottle-add]').addEventListener('click', () => this.addBottle(bottle));
      });
      this.purchaseTypeInputs.forEach((input) => {
        input.addEventListener('change', () => this.render());
      });
      this.ctaButton.addEventListener('click', () => this.addToCart());

      this.setBoxSize(this.sizeButtons[0]);
    }

    formatMoney(cents) {
      const amount = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return `$ ${amount}`;
    }

    setBoxSize(button) {
      this.sizeButtons.forEach((b) => b.classList.toggle('is-active', b === button));
      this.boxSize = parseInt(button.dataset.proSizeOption, 10);
      this.items = [];
      this.sizeLabelEl.textContent = this.boxSize;
      this.render();
    }

    addBottle(bottle) {
      if (this.items.length >= this.boxSize) return;
      this.items.push({
        name: bottle.dataset.name,
        price: parseInt(bottle.dataset.price, 10),
        variantId: bottle.dataset.variantId,
      });
      this.render();
    }

    removeItem(index) {
      this.items.splice(index, 1);
      this.render();
    }

    render() {
      this.slotsEl.innerHTML = '';
      for (let i = 0; i < this.boxSize; i += 1) {
        const slot = document.createElement('button');
        slot.type = 'button';
        slot.className = 'subscribe-box__slot';
        const item = this.items[i];
        if (item) {
          slot.classList.add('is-filled');
          slot.textContent = item.name;
          slot.addEventListener('click', () => this.removeItem(i));
        } else {
          slot.textContent = '+';
          slot.disabled = true;
        }
        this.slotsEl.appendChild(slot);
      }

      this.countEl.textContent = this.items.length;

      const individualTotal = this.items.reduce((sum, item) => sum + item.price, 0);
      const oncePriceCents = Math.round(individualTotal * 0.8);
      const subscribePriceCents = Math.round(individualTotal * 0.8 * 0.9);
      const savings = individualTotal - oncePriceCents;

      if (this.items.length === this.boxSize && savings > 0) {
        this.savingsEl.hidden = false;
        this.savingsAmountEl.textContent = this.formatMoney(savings);
        this.savingsPercentEl.textContent = Math.round((savings / individualTotal) * 100);
      } else {
        this.savingsEl.hidden = true;
      }

      this.priceOnceEl.textContent = this.formatMoney(oncePriceCents);
      this.priceSubscribeEl.textContent = this.formatMoney(subscribePriceCents);

      const isSubscribe = this.querySelector('[data-pro-purchase-type]:checked').value === 'subscribe';
      this.frequencySelect.hidden = !isSubscribe;

      const isComplete = this.items.length === this.boxSize;
      this.ctaButton.disabled = !isComplete;
      this.ctaButton.textContent = isComplete
        ? this.ctaButton.dataset.labelReady
        : this.ctaButton.dataset.labelIncomplete;
    }

    async addToCart() {
      const isSubscribe = this.querySelector('[data-pro-purchase-type]:checked').value === 'subscribe';

      const grouped = {};
      this.items.forEach((item) => {
        const numericId = item.variantId.split('/').pop();
        grouped[numericId] = (grouped[numericId] || 0) + 1;
      });

      const payload = {
        items: Object.entries(grouped).map(([id, quantity]) => {
          const line = { id: Number(id), quantity };
          if (isSubscribe) line.selling_plan = Number(this.frequencySelect.value);
          return line;
        }),
      };

      this.ctaButton.disabled = true;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      this.items = [];
      this.render();
    }
  }

  customElements.define('pro-builder', ProBuilder);

  class SubscribeBuilder extends HTMLElement {
    connectedCallback() {
      this.boxSize = 6;
      this.items = [];

      this.filterButtons = this.querySelectorAll('[data-filter]');
      this.sizeButtons = this.querySelectorAll('[data-box-size-option]');
      this.bottles = this.querySelectorAll('[data-bottle]');
      this.slotsEl = this.querySelector('[data-box-slots]');
      this.countEl = this.querySelector('[data-box-count]');
      this.sizeLabelEl = this.querySelector('[data-box-size-label]');
      this.savingsEl = this.querySelector('[data-box-savings]');
      this.savingsAmountEl = this.querySelector('[data-savings-amount]');
      this.savingsPercentEl = this.querySelector('[data-savings-percent]');
      this.priceOnceEl = this.querySelector('[data-price-once]');
      this.priceSubscribeEl = this.querySelector('[data-price-subscribe]');
      this.purchaseTypeInputs = this.querySelectorAll('[data-purchase-type]');
      this.frequencySelect = this.querySelector('[data-frequency-select]');
      this.ctaButton = this.querySelector('[data-box-add-to-cart]');

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => this.setFilter(button));
      });
      this.sizeButtons.forEach((button) => {
        button.addEventListener('click', () => this.setBoxSize(button));
      });
      this.bottles.forEach((bottle) => {
        bottle.querySelector('[data-bottle-add]').addEventListener('click', () => this.addBottle(bottle));
      });
      this.purchaseTypeInputs.forEach((input) => {
        input.addEventListener('change', () => this.render());
      });
      this.ctaButton.addEventListener('click', () => this.addToCart());

      this.setBoxSize(this.sizeButtons[0]);

      // "Arma tu caja" links from the box product pages land on
      // /pages/suscribir#caja-6 (or #caja-12): open this builder at that size.
      this.applyHash = () => {
        const match = window.location.hash.match(/^#caja-(6|12)$/);
        if (!match) return;
        const sizeButton = [...this.sizeButtons].find((b) => b.dataset.boxSizeOption === match[1]);
        document.querySelector('[data-plan-selector]')?.select?.('business');
        if (sizeButton) this.setBoxSize(sizeButton);
        this.scrollIntoView({ block: 'start' });
      };
      this.applyHash();
      window.addEventListener('hashchange', this.applyHash);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.applyHash);
    }

    formatMoney(cents) {
      const amount = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return `$ ${amount}`;
    }

    setFilter(button) {
      this.filterButtons.forEach((b) => b.classList.toggle('is-active', b === button));
      const filter = button.dataset.filter;
      this.bottles.forEach((bottle) => {
        const categories = bottle.dataset.category.split(' ');
        bottle.hidden = !categories.includes(filter);
      });
    }

    setBoxSize(button) {
      this.sizeButtons.forEach((b) => b.classList.toggle('is-active', b === button));
      this.boxSize = parseInt(button.dataset.boxSizeOption, 10);
      this.boxPriceCents = parseInt(button.dataset.boxPrice, 10);
      this.items = [];
      this.sizeLabelEl.textContent = this.boxSize;
      this.render();
    }

    addBottle(bottle) {
      if (this.items.length >= this.boxSize) return;
      this.items.push({
        name: bottle.dataset.name,
        price: parseInt(bottle.dataset.price, 10),
      });
      this.render();
    }

    removeItem(index) {
      this.items.splice(index, 1);
      this.render();
    }

    render() {
      this.slotsEl.innerHTML = '';
      for (let i = 0; i < this.boxSize; i += 1) {
        const slot = document.createElement('button');
        slot.type = 'button';
        slot.className = 'subscribe-box__slot';
        const item = this.items[i];
        if (item) {
          slot.classList.add('is-filled');
          slot.textContent = item.name;
          slot.addEventListener('click', () => this.removeItem(i));
        } else {
          slot.textContent = '+';
          slot.disabled = true;
        }
        this.slotsEl.appendChild(slot);
      }

      this.countEl.textContent = this.items.length;

      const individualTotal = this.items.reduce((sum, item) => sum + item.price, 0);
      const savings = individualTotal - this.boxPriceCents;
      if (this.items.length === this.boxSize && savings > 0) {
        this.savingsEl.hidden = false;
        this.savingsAmountEl.textContent = this.formatMoney(savings);
        this.savingsPercentEl.textContent = Math.round((savings / individualTotal) * 100);
      } else {
        this.savingsEl.hidden = true;
      }

      this.priceOnceEl.textContent = this.formatMoney(this.boxPriceCents);
      this.priceSubscribeEl.textContent = this.formatMoney(Math.round(this.boxPriceCents * 0.9));

      const isSubscribe = this.querySelector('[data-purchase-type]:checked').value === 'subscribe';
      this.frequencySelect.hidden = !isSubscribe;

      const isComplete = this.items.length === this.boxSize;
      this.ctaButton.disabled = !isComplete;
      this.ctaButton.textContent = isComplete
        ? this.ctaButton.dataset.labelReady
        : this.ctaButton.dataset.labelIncomplete;
    }

    async addToCart() {
      const isSubscribe = this.querySelector('[data-purchase-type]:checked').value === 'subscribe';
      const variantId = this.boxSize === 6
        ? this.ctaButton.dataset.box6VariantId
        : this.ctaButton.dataset.box12VariantId;
      const variantNumericId = variantId.split('/').pop();

      const propertiesSummary = this.items.map((item) => item.name).join(', ');

      const payload = {
        items: [
          {
            id: Number(variantNumericId),
            quantity: 1,
            properties: { Botellas: propertiesSummary },
          },
        ],
      };
      if (isSubscribe) {
        payload.items[0].selling_plan = Number(this.frequencySelect.value);
      }

      this.ctaButton.disabled = true;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));

      this.items = [];
      this.render();
    }
  }

  customElements.define('subscribe-builder', SubscribeBuilder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zero-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    function initZeroBar(root) {
      if (!root || root.dataset.zbReady) return;
      root.dataset.zbReady = 'true';
      root.classList.add('zb--js');

      /* Reveal on scroll */
      const revealer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            revealer.unobserve(entry.target);
          });
        },
        { threshold: 0.12 }
      );
      root.querySelectorAll('[data-zb-reveal]').forEach((el) => revealer.observe(el));

      /* Scroll-linked motion: parallax floaters, flip line, pinned scenes, floating pill */
      const floaters = [...root.querySelectorAll('[data-zb-speed]')];
      const flips = [...root.querySelectorAll('[data-zb-flip]')];
      const cinema = root.querySelector('[data-zb-cinema]');
      const scenes = cinema ? [...cinema.querySelectorAll('.zb-scene')] : [];
      const dots = cinema ? [...cinema.querySelectorAll('.zb-cinema__dot')] : [];
      const hero = root.querySelector('.zb-hero');
      const closing = root.querySelector('.zb-closing');
      const pill = root.querySelector('[data-zb-pill]');
      let pointerX = 0;
      let pointerY = 0;
      let activeScene = 0;
      let queued = false;

      function update() {
        queued = false;
        const vh = window.innerHeight;

        if (!reduceMotion) {
          floaters.forEach((el) => {
            const box = el.parentElement.getBoundingClientRect();
            if (box.bottom < -200 || box.top > vh + 200) return;
            const speed = parseFloat(el.dataset.zbSpeed) || 0;
            const x = pointerX * speed * 80;
            const y = -box.top * speed + pointerY * speed * 50;
            el.style.translate = `${x.toFixed(1)}px ${y.toFixed(1)}px`;
          });

          flips.forEach((el) => {
            const box = el.getBoundingClientRect();
            const progress = clamp((vh * 0.5 - box.top) / (vh * 0.6), 0, 1);
            el.style.setProperty('--flip', `${(progress * 180).toFixed(1)}deg`);
          });
        }

        if (cinema && scenes.length) {
          const box = cinema.getBoundingClientRect();
          const travel = Math.max(cinema.offsetHeight - vh, 1);
          const index = Math.floor(clamp(-box.top / travel, 0, 0.9999) * scenes.length);
          if (index !== activeScene) {
            scenes[activeScene].classList.remove('is-active');
            dots[activeScene]?.classList.remove('is-active');
            scenes[index].classList.add('is-active');
            dots[index]?.classList.add('is-active');
            activeScene = index;
          }
        }

        if (pill && hero) {
          const heroGone = hero.getBoundingClientRect().bottom < 0;
          const closingIn = closing ? closing.getBoundingClientRect().top < vh : false;
          pill.classList.toggle('is-visible', heroGone && !closingIn);
        }
      }

      const requestUpdate = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      };
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      if (!reduceMotion && window.matchMedia('(pointer: fine)').matches) {
        hero?.addEventListener('pointermove', (event) => {
          pointerX = event.clientX / window.innerWidth - 0.5;
          pointerY = event.clientY / window.innerHeight - 0.5;
          requestUpdate();
        });
      }
      update();

      /* "0" wall: cells swap colors while visible */
      const wall = root.querySelector('[data-zb-wall]');
      if (wall && !reduceMotion) {
        const cells = [...wall.querySelectorAll('.zb-wall__cell')];
        const shuffle = (cell) => (cell.dataset.c = String(Math.floor(Math.random() * 6)));
        let timer = null;
        new IntersectionObserver(([entry]) => {
          clearInterval(timer);
          if (!entry.isIntersecting) return;
          timer = setInterval(() => {
            for (let i = 0; i < 5; i++) shuffle(cells[Math.floor(Math.random() * cells.length)]);
          }, 450);
        }).observe(wall);
        cells.forEach((cell) => cell.addEventListener('pointerenter', () => shuffle(cell)));
      }

      initCustom(root);
      initQuote(root);
    }

    /* "Design your can": live label preview; the CTA pre-fills the quote wizard */
    function initCustom(root) {
      const custom = root.querySelector('[data-zb-custom]');
      if (!custom) return;
      const pack = custom.querySelector('[data-zb-pack]');
      const names = custom.querySelector('[data-zb-c-names]');
      const date = custom.querySelector('[data-zb-c-date]');
      const outNames = custom.querySelector('[data-zb-c-out-names]');
      const outDate = custom.querySelector('[data-zb-c-out-date]');
      const cta = custom.querySelector('[data-zb-custom-cta]');
      const selected = (attr) => custom.querySelector(`[${attr}]:checked`);

      const pop = () => {
        pack.classList.remove('is-pop');
        void pack.offsetWidth;
        pack.classList.add('is-pop');
      };
      const render = () => {
        outNames.textContent = names.value.trim() || names.defaultValue;
        outDate.textContent = date.value.trim();
        pack.style.setProperty('--label', selected('data-zb-c-color').value);
        pack.classList.toggle('zb-pack--bottle', selected('data-zb-c-format').value === 'bottle');
        pack.classList.toggle('zb-pack--can', selected('data-zb-c-format').value === 'can');
      };
      custom.addEventListener('input', () => {
        render();
        pop();
      });
      render();

      cta.addEventListener('click', () => {
        const format = selected('data-zb-c-format');
        cta.dataset.zbService = format.value === 'bottle' ? custom.dataset.bottleService : custom.dataset.canService;
        const notes = root.querySelector('[data-zb-notes]');
        if (notes) {
          const label = format.closest('label').textContent.trim();
          notes.value = `${label}: ${outNames.textContent} · ${outDate.textContent} · ${selected('data-zb-c-color').dataset.name}`;
        }
      });
    }

    function initQuote(root) {
      const dialog = root.querySelector('[data-zb-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const form = dialog.querySelector('form');
      const strings = {};
      root.querySelectorAll('[data-zb-strings]').forEach((template) => {
        template.content.querySelectorAll('[data-k]').forEach((s) => (strings[s.dataset.k] = s.textContent.trim()));
      });

      const open = (serviceId) => {
        if (serviceId) {
          const box = dialog.querySelector(`[data-zb-drink="${serviceId}"]`);
          if (box) box.checked = true;
        }
        if (!dialog.open) dialog.showModal();
      };
      root.querySelectorAll('[data-zb-open]').forEach((opener) => {
        opener.addEventListener('click', (event) => {
          event.preventDefault();
          open(opener.dataset.zbService);
        });
      });
      dialog.querySelectorAll('[data-zb-close]').forEach((btn) => btn.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      if (dialog.querySelector('[data-zb-success]')) {
        open();
        return;
      }

      const steps = [...dialog.querySelectorAll('[data-zb-step]')];
      const next = dialog.querySelector('[data-zb-next]');
      const back = dialog.querySelector('[data-zb-back]');
      const error = dialog.querySelector('[data-zb-error]');
      const count = dialog.querySelector('[data-zb-count]');
      const bar = dialog.querySelector('[data-zb-bar]');
      const summary = dialog.querySelector('[data-zb-summary]');
      const wa = dialog.querySelector('[data-zb-wa]');
      const drinksField = dialog.querySelector('[data-zb-drinks-field]');
      const guests = dialog.querySelector('[data-zb-guests]');
      const guestsOut = dialog.querySelector('[data-zb-guests-out]');
      const venue = dialog.querySelector('[data-zb-venue]');
      const date = dialog.querySelector('[data-zb-date]');
      const noDate = dialog.querySelector('[data-zb-nodate]');
      const presets = [...dialog.querySelectorAll('[data-zb-preset]')];
      let current = 0;

      const drinks = () => [...dialog.querySelectorAll('[data-zb-drink]:checked')].map((box) => box.value);
      const checkedValue = (name) => dialog.querySelector(`input[name="${name}"]:checked`)?.value || '';
      const guestsLabel = () => (guests.value === guests.max ? `${guests.value}+` : guests.value);

      function answers() {
        return [
          [strings.drinks, drinks().join(', ')],
          [strings.event, checkedValue('contact[Tipo de evento]')],
          [strings.guests, guestsLabel()],
          [strings.place, [checkedValue('contact[Ciudad]'), venue.value.trim()].filter(Boolean).join(' · ')],
          [strings.date, noDate.checked ? strings.no_date : date.value],
        ].filter(([, value]) => value);
      }

      function go(index) {
        current = index;
        steps.forEach((step, i) => (step.hidden = i !== index));
        const last = index === steps.length - 1;
        back.hidden = index === 0;
        next.textContent = last ? next.dataset.labelSubmit : next.dataset.labelNext;
        count.textContent = index + 1;
        bar.style.width = `${((index + 1) / steps.length) * 100}%`;
        form.style.setProperty('--step-bg-current', steps[index].style.getPropertyValue('--step-bg'));
        error.hidden = true;
        if (last) {
          const list = answers();
          summary.replaceChildren(
            ...list.map(([label, value]) => {
              const chip = document.createElement('span');
              chip.textContent = `${label}: ${value}`;
              return chip;
            })
          );
          if (wa) {
            const text = [strings.wa_intro, ...list.map(([label, value]) => `• ${label}: ${value}`)].join('\n');
            wa.href = `${wa.href.split('?')[0]}?text=${encodeURIComponent(text)}`;
          }
        }
        if (dialog.open) steps[index].querySelector('input, button')?.focus({ preventScroll: true });
      }

      function valid(index) {
        const step = steps[index];
        switch (step.dataset.zbStep) {
          case 'drinks':
            return drinks().length > 0;
          case 'event':
            return Boolean(checkedValue('contact[Tipo de evento]'));
          case 'place':
            return Boolean(checkedValue('contact[Ciudad]'));
          case 'contact':
            return [...step.querySelectorAll('input[required]')].every((input) => input.reportValidity());
          default:
            return true;
        }
      }

      next.addEventListener('click', () => {
        if (!valid(current)) {
          error.hidden = false;
          return;
        }
        if (current < steps.length - 1) {
          go(current + 1);
          return;
        }
        form.requestSubmit();
      });
      back.addEventListener('click', () => go(Math.max(0, current - 1)));

      dialog.querySelectorAll('[data-zb-auto]').forEach((radio) =>
        radio.addEventListener('change', () => setTimeout(() => go(current + 1), 280))
      );

      const syncGuests = () => {
        guestsOut.textContent = guestsLabel();
        presets.forEach((preset) => preset.classList.toggle('is-on', preset.dataset.zbPreset === guests.value));
      };
      guests.addEventListener('input', syncGuests);
      presets.forEach((preset) =>
        preset.addEventListener('click', () => {
          guests.value = preset.dataset.zbPreset;
          syncGuests();
        })
      );
      noDate.addEventListener('change', () => (date.disabled = noDate.checked));
      form.addEventListener('submit', (event) => {
        if (current !== steps.length - 1) {
          event.preventDefault();
          next.click();
          return;
        }
        drinksField.value = drinks().join(', ');
        if (noDate.checked) date.value = '';
      });

      syncGuests();
      go(0);

      if (dialog.querySelector('[data-zb-server-error]')) {
        open();
        go(steps.length - 1);
      } else if (window.location.hash === '#cotizar') {
        open();
      }
    }

    const boot = () => document.querySelectorAll('[data-zb]').forEach(initZeroBar);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
